/**
 * DataListItem Component
 * Generic list row component with column-based layout
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./DataListItem.scss";

export const DataListItem = React.memo(
  ({ to, onClick, columns = [], actions, className = "" }) => {
    const ItemWrapper = to ? Link : "div";
    const wrapperProps = to ? { to } : {};

    // Build grid template columns from column widths
    // Add "auto" for actions column if actions exist
    const columnsTemplate = columns.map((col) => col.width || "1fr").join(" ");
    const gridTemplate = actions 
      ? `${columnsTemplate} auto` 
      : columnsTemplate;

    // Build style object
    const style = {
      gridTemplateColumns: gridTemplate,
      ...(onClick && !to ? { cursor: "pointer" } : {}),
    };

    // Build event handlers
    const handlers = onClick && !to ? { onClick } : {};

    return (
      <ItemWrapper
        className={`data-list-item ${className}`}
        style={style}
        {...wrapperProps}
        {...handlers}
      >
        {columns.map((column, index) => (
          <div
            key={index}
            className="data-list-item__column"
            style={{
              textAlign: column.align || "left",
              justifyContent:
                column.align === "right"
                  ? "flex-end"
                  : column.align === "center"
                  ? "center"
                  : "flex-start",
            }}
          >
            {column.content}
          </div>
        ))}
        {actions && (
          <div className="data-list-item__actions">
            {actions}
          </div>
        )}
      </ItemWrapper>
    );
  }
);

DataListItem.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      width: PropTypes.string, // e.g., '200px', '2fr', 'minmax(100px, 1fr)'
      align: PropTypes.oneOf(["left", "center", "right"]),
    })
  ).isRequired,
  actions: PropTypes.node,
  className: PropTypes.string,
};
